import React from "react";
import ProspectsContainer from "../containers/Prospects/ProspectsContainer";
import NavBarContainer from "../containers/NavBar/NavBarContainer";


const ProspectsPage = ({type}) => {
    return (
        <div className="flex flex-col h-screen bg-slate-100">
            <nav className="fixed top-0 left-0 right-0 z-50 h-14 bg-gradient-to-r from-custom-green-ccard-2 to-custom-green-ccard-1">
                <NavBarContainer />
            </nav>
            <div className="mt-14 overflow-auto flex-1">
                <ProspectsContainer type={type} />
            </div>
        </div>
    );
}

export default ProspectsPage;